module.exports = __webpack_public_path__ + "pin_orange.3a39a5.png";